import React from "react";

const NoDataFound = ({
  text = "No Data Found",
  className = "",
}) => {
  return (
    <div className={`no_data_found_div g_center ${className}`}>
      <p className="text-center">{text}</p>
    </div>
  );
};

export default NoDataFound;
